export const gtmRecommendationViewEvent = (blockType: string, category: string) => ({
  event: 'recommendation_view',
  block_type: blockType,
  category,
});

export default gtmRecommendationViewEvent;
